import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ElevionLogicalNode, ElevionNode } from 'utils/elevion';

import { AttributeFormFieldValues } from '../../../../../customAttributeModalForm.types';
import { ElevionConditionLeaf } from '../elevionConditionLeaf';
import { ElevionConditionLogical } from '../elevionConditionLogical';

type ElevionNodeProps = {
  readonly parentName?: string;
  readonly index?: number;
};

export const ElevionCondition = memo(function ElevionNode({
  parentName,
  index,
}: ElevionNodeProps): JSX.Element | null {
  const {
    control,
    // TODO: [TEAMS-13693] remove omit after updating to RHF v8
  } = useFormContext<Omit<AttributeFormFieldValues, 'options'>>();

  const name =
    parentName !== undefined && index !== undefined
      ? // TODO fix any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (`${parentName}.${index}` as any)
      : 'visibility_condition';

  const node: ElevionNode = useWatch({
    control,
    name,
  });

  if (!node) {
    return null;
  }

  if (('logicalOp' satisfies keyof ElevionLogicalNode) in node) {
    return <ElevionConditionLogical index={index} parentName={parentName} />;
  }

  return <ElevionConditionLeaf index={index} parentName={parentName} />;
});
